import React, { useState } from "react";
import { Field, Label, Switch } from "@headlessui/react";
import { useModeContinuous } from "../../hooks/useModeContinuous";

const AutoplayButton = () => {
  const { isModeContinuous, toggleModeContinuous } = useModeContinuous();

  return (
    <Field className="flex flex-col items-center gap-2">
      <Label className="text-xs text-center font-semibold text-slate-50 select-none">
        Modo
        <br />
        continuo
      </Label>
      <Switch
        checked={isModeContinuous}
        onChange={toggleModeContinuous}
        className="group inline-flex h-8 w-16 items-center rounded-full bg-gray-300 transition data-[checked]:bg-blue-600"
      >
        <span className="flex size-6 translate-x-1 rounded-full items-center justify-center bg-white transition group-data-[checked]:translate-x-9">
          {isModeContinuous ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 163.9 163.9"
              className="h-3 w-3 fill-blue-600"
            >
              <path
                d="M34.9 3.6C20-4.9 8 2.1 8 19.1v125.6c0 17 12 24 26.8 15.6l109.8-63c14.7-8.5 14.7-22.2 0-30.7z"
                data-original="#000000"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlSpace="preserve"
              viewBox="0 0 24 24"
              className="h-3 w-3 fill-gray-600"
            >
              <g data-name="Layer 2">
                <rect
                  width={5}
                  height={20}
                  x={4.5}
                  y={2}
                  data-original="#000000"
                  rx={2.5}
                />
                <rect
                  width={5}
                  height={20}
                  x={14.5}
                  y={2}
                  data-original="#000000"
                  rx={2.5}
                />
              </g>
            </svg>
          )}
        </span>
      </Switch>
    </Field>
  );
};

export { AutoplayButton };
